import React from 'react'
import {
    Form,
  Input,
  Radio,
  Space,
  Button,Selector,TextArea,Image,DatePicker,Divider,Grid,NavBar,Ellipsis,Toast,Popup
} from 'antd-mobile-v5';
import { FillinOutline,StarOutline,StarFill,AppOutline } from 'antd-mobile-icons'
import dayjs from 'dayjs'
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import {
    GetPlanetInfo,InsertPlanetFamilyGroup,SavePlanetFamilyGroup,SendPlanetFamilyGroup
} from '../../service/service';
import { environment } from '../../service/baseUrl';

import '../FormView/index.css'

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            fileList: [],
            userInfo: {},
            textArea: "",
            IsAdmin: false,
            CunZaiAdmin: false,

            isUrl: false,
            visiblePopup: false,
        };
    }

    componentDidMount() {
        var that = this;

        const searchParams = new URLSearchParams(window.location.search);
        const planetId = searchParams.get('planetId');

        if (planetId) {
            GetPlanetInfo(planetId).then(res => {
                if (res.success) {
                    var result = res.result;
                    //result.headImg = environment.apiEndpoint + "/NNFiles/Img/" + result.headImg;
                    result.headImg = result.headImg == null ?
                        "https://api.weibinyi.com/images/niannian/thtx.jpg" :
                        environment.apiEndpoint + "/NNFiles/Img/" + result.headImg;
                    result.planetFamilyGroupDtos.map(item => {
                        var str = environment.apiEndpoint + "/NNFiles/Img/" + item.creatorUserUrl;
                        var urls = str.split("https://").filter(Boolean); 
                        item.creatorUserUrl = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                    })
                    result.planetFamilyGroupDtos = result.planetFamilyGroupDtos.filter(x => x.isAdmin);
                    
                    var isAdmin = false;
                    var CunZaiAdmin = false;
                    
                    if (res.result.openId == localStorage.getItem("openid")) {
                        CunZaiAdmin = true;
                    } else {
                        var items = res.result.planetFamilyGroupDtos.filter(x => x.openId == localStorage.getItem("openid"));
                        if (items.length > 0) {
                            CunZaiAdmin = true;
                        }
                    }

                    if (result.planetFamilyGroupDtos.length > 0) {
                        isAdmin = result.planetFamilyGroupDtos[0].isAdmin;
                    }

                    that.setState({
                        id: planetId,
                        isUrl: true,
                        IsAdmin: isAdmin,
                        CunZaiAdmin: CunZaiAdmin,
                        userInfo: result,
                    })
                }
            })

            that.insertPlanetFamilyGroup();
            return;
        }

        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            GetPlanetInfo(id).then(res => {
                if (res.success) {
                    var result = res.result;
                    // result.headImg = environment.apiEndpoint + "/NNFiles/Img/" + result.headImg;
                    result.headImg = result.headImg == null ?
                        "https://api.weibinyi.com/images/niannian/thtx.jpg" :
                        environment.apiEndpoint + "/NNFiles/Img/" + result.headImg;
                    result.planetFamilyGroupDtos.map(item => {
                        var str = environment.apiEndpoint + "/NNFiles/Img/" + item.creatorUserUrl;
                        var urls = str.split("https://").filter(Boolean); 
                        item.creatorUserUrl = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                    })
                    result.planetFamilyGroupDtos = result.planetFamilyGroupDtos.filter(x => x.isAdmin);
                    
                    var isAdmin = false;
                    var CunZaiAdmin = false;
                    
                    if (res.result.openId == localStorage.getItem("openid")) {
                        CunZaiAdmin = true;
                    } else {
                        var items = res.result.planetFamilyGroupDtos.filter(x => x.openId == localStorage.getItem("openid"));
                        if (items.length > 0) {
                            CunZaiAdmin = true;
                        }
                    }
                    
                    if (result.planetFamilyGroupDtos.length > 0) {
                        isAdmin = result.planetFamilyGroupDtos[0].isAdmin;
                    }
                    that.setState({
                        id: id,
                        IsAdmin: isAdmin,
                        CunZaiAdmin: CunZaiAdmin,
                        userInfo: result,
                    })
                }
            })
        }
    }

    insertPlanetFamilyGroup = () => {
        var that = this;
        const searchParams = new URLSearchParams(window.location.search);
        const planetId = searchParams.get('planetId');

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            that.insertPlanetFamilyGroup();
            return;
        }
        var openid = localStorage.getItem("openid")
        if (openid == null || openid == "" || openid == undefined) {
            that.insertPlanetFamilyGroup();
        } else {
            // InsertPlanetFamilyGroup({
            //     PlanetId: planetId,
            //     OpenId: openid,
            // }).then(res => {
            //     if (res.success) {
            //     }
            // })

            var planetIdStr = localStorage.getItem("planetId");
            if (planetIdStr == null || planetIdStr == undefined || planetIdStr == "" || planetIdStr != planetId) 
            {
                InsertPlanetFamilyGroup({
                    PlanetId: planetId,
                    OpenId: openid,
                }).then(res => {
                    localStorage.setItem("planetId", planetId);
                    if (res.success) {
    
                    }
                })
            }
        }
    }

    SendPlanetFamilyGroup = () => {

        // if (this.state.textArea == "") {
        //     Toast.show({
        //         content: '请输入关键词！'
        //     })
        //     return ;
        // }

        // Toast.show({
        //     icon: 'success',
        //     content: '待开发'
        // })
        // return;

        var that = this;
        // const searchParams = new URLSearchParams(window.location.search);
        // const planetId = searchParams.get('planetId');
        var openid = localStorage.getItem("openid");
        SendPlanetFamilyGroup({
            PlanetId: that.state.id,
            OpenId: openid,
            Remark: this.state.textArea,
        }).then(res => {
            if (res.success) {
                Toast.show({
                    icon: 'success',
                    content: '提交成功！'
                })

                that.setState({
                    IsAdmin: true,
                })
                // Toast.show({
                //     icon: 'success',
                //     content: '提交成功！请等待亲友进行审核'
                // })
            }
        })
    }

    render() {
        const handleCopy = async () => {
            const textToCopy = environment.domainUrl + '/formView?planetId=' + this.state.id;

            try {
                await navigator.clipboard.writeText(textToCopy);
                
                Toast.show({
                    icon: 'success',
                    content: '复制成功: ' + textToCopy,
                  })
            } catch (err) {
                console.error('复制失败:', err);
                fallbackCopy(textToCopy);
            }
        };

        const fallbackCopy = (text) => {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            document.body.appendChild(textarea);
            textarea.select();

            try {
                document.execCommand('copy');
                Toast.show({
                    icon: 'success',
                    content: '复制成功: ' + text,
                  })
            } catch (err) {
                Toast.show({
                    content: '复制失败！',
                  })
            }

            document.body.removeChild(textarea);
        };

        return (
            <div style={{ height: "100%", width: "100%" }}>
                <NavBar back={this.state.isUrl ? "首页" : "返回"} onBack={() => {
                    if (this.state.isUrl) {
                        this.props.navigate('/index', { replace: true });
                    } else {
                        this.props.navigate('/home?planetId=' + this.state.id, { replace: true, state: { id: this.state.id } });
                    }
                }} right={<>
                    {
                        this.state.CunZaiAdmin ?
                            <FillinOutline fontSize="20px" style={{ marginTop: "5px" }}
                                color='var(--adm-color-primary)' onClick={() => {
                                    this.props.navigate('/formEdit', { replace: true, state: { id: this.state.id } });
                                }} /> : null
                    }
                </>}>
                    生平
                </NavBar>

                <div style={{
                    height: "85%", backgroundImage: "url('https://api.weibinyi.com/images/niannian/1/2-08.png')"
                    , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", paddingTop: "10%", overflowY: "scroll"
                }}>

                    <div style={{ width: "92%", backgroundColor: "#fff", marginLeft: "4%", borderRadius: "2%" }}>

                        {/* <div style={{ position: "absolute", right: "10px", marginTop: "-8px" }}>
                            <span style={{ fontSize: "13px", textDecoration: "underline" }}>存储仓库</span>
                            <AppOutline fontSize={13} color='var(--adm-color-danger)' />
                        </div> */}

                        <div style={{ paddingTop: "1%" }}>
                            <Grid columns={6} gap={8} style={{ marginTop: "12px" }}>
                                <Grid.Item span={2}>
                                    <div style={{ position: "relative", width: "90px", height: "90px", marginLeft: "30%" }}>
                                        <Image
                                            src={this.state.userInfo.headImg}
                                            width={90}
                                            height={90}
                                            fit='cover'
                                            style={{ borderRadius: "45px" }}
                                        />

                                        {
                                            (this.state.userInfo.planetAuthDtos == null
                                                || this.state.userInfo.planetAuthDtos.length == 0) ? null :
                                                <Image
                                                    src={"https://api.weibinyi.com/images/niannian/1/2-12.png"}
                                                    width={20}
                                                    height={20}
                                                    fit='cover'
                                                    style={{
                                                        position: "absolute",
                                                        bottom: 0,
                                                        right: '3px',
                                                    }}
                                                />
                                        }
                                    </div>
                                </Grid.Item>
                                <Grid.Item span={4}>
                                    <div style={{ marginLeft: "15px", lineHeight: "20px", fontSize: "11px", color: "#878787" }}>
                                        <div style={{ marginTop: "9px", fontSize: "16px", fontWeight: "600", color: "#000" }}>
                                            {this.state.userInfo.name}
                                </div>
                                        <div style={{ marginTop: "5px" }}>
                                            <span>
                                                已化作星星
                                                {parseInt((new Date() - dayjs(this.state.userInfo.creationTime))
                                                    / (1000 * 60 * 60 * 24))}
                                                天
                                            </span>
                                        </div>
                                        <div style={{ marginTop: "-4px" }}>
                                            <span>ID：{this.state.userInfo.userNumber}</span>
                                        </div>

                                        <div style={{
                                            marginTop: "0px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "40px"
                                        }}>
                                            {/* 去认证 / 已认证 */}
                                            {(this.state.userInfo.planetAuthDtos == null || this.state.userInfo.planetAuthDtos.length == 0) ? (
                                                <span
                                                    style={{
                                                        textDecoration: "underline",
                                                        cursor: "pointer",
                                                        display: "inline-flex",
                                                        alignItems: "center"
                                                    }}
                                                    onClick={() => {
                                                        if (this.state.userInfo.openId == localStorage.getItem("openid")) {
                                                            this.props.navigate('/userAuth', { replace: true, state: { id: this.state.id } });
                                                        }
                                                    }}
                                                >
                                                    去认证
        </span>
                                            ) : (
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <span style={{ cursor: "pointer" }} onClick={() => { }}>
                                                            已认证
            </span>
                                                        <Image
                                                            src={"https://api.weibinyi.com/images/niannian/1/2-13.png"}
                                                            width={12}
                                                            height={12}
                                                            fit='cover'
                                                            style={{
                                                                display: "inline-flex",
                                                                marginLeft: "3px",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() => { }}
                                                        />
                                                    </div>
                                                )}

                                            {/* 空间 + 图片 + 去升级（作为一个整体） */}
                                            <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "5px",
                                                height: "100%"
                                            }}>
                                                <span
                                                    style={{
                                                        cursor: "pointer",
                                                        display: "inline-flex",
                                                        alignItems: "center"
                                                    }}
                                                    onClick={() => {
                                                        this.props.navigate('/space', { replace: true, state: { id: this.state.id } });
                                                    }}
                                                >
                                                    空间
        </span>
                                                <Image
                                                    src={"https://api.weibinyi.com/images/niannian/1/3-14.png"}
                                                    width={50}
                                                    height={12}
                                                    fit='contain'
                                                    style={{
                                                        cursor: "pointer",
                                                        display: "inline-flex",
                                                        alignItems: "center"
                                                    }}
                                                    onClick={() => {
                                                        this.props.navigate('/space', { replace: true, state: { id: this.state.id } });
                                                    }}
                                                />
                                                <span
                                                    style={{
                                                        cursor: "pointer",
                                                        textDecoration: "underline",
                                                        display: "inline-flex",
                                                        alignItems: "center"
                                                    }}
                                                    onClick={() => {
                                                        this.props.navigate('/space', { replace: true, state: { id: this.state.id } });
                                                    }}
                                                >
                                                    去升级
        </span>
                                            </div>
                                        </div>

                                    </div>
                                </Grid.Item>
                                <Grid.Item span={6}>
                                    <div style={{
                                        borderBottom: "solid 2px #e5e5e5", width: "92%",
                                        marginLeft: "4%", marginTop: "5px"
                                    }}></div>
                                </Grid.Item>

                                <Grid.Item span={3}>
                                    <span className="titleLeft">
                                        性别
                                    </span>
                                    <span className="titleRight">
                                        {
                                            this.state.userInfo.sex ? "女" : "男"
                                        }
                                    </span>
                                </Grid.Item>
                                <Grid.Item span={3}>
                                    <span className="titleLeft">
                                        民族
                                    </span>
                                    <span className="titleRight">
                                        {
                                            this.state.userInfo.ethnicity == null ? "待完善" : this.state.userInfo.ethnicity
                                        }
                                    </span>
                                </Grid.Item>
                                <Grid.Item span={3}>
                                    <span className="titleLeft">
                                        籍贯
                                    </span>
                                    <span className="titleRight">
                                        {
                                            this.state.userInfo.hometown == null ? "待完善" :
                                                this.state.userInfo.hometown.split("-")[0]
                                        }
                                    </span>
                                </Grid.Item>
                                <Grid.Item span={3}>
                                    <span className="titleLeft">
                                        信仰
                                    </span>
                                    <span className="titleRight">
                                        {
                                            this.state.userInfo.beliefName == null ? "待完善" : this.state.userInfo.beliefName
                                        }
                                    </span>
                                </Grid.Item>
                                <Grid.Item span={3}>
                                    <span className="titleLeft">
                                        爱好
                                    </span>
                                    <span className="titleRight">
                                        {
                                            this.state.userInfo.hobby == null ? "待完善" : this.state.userInfo.hobby
                                        }
                                    </span>
                                </Grid.Item>
                                <Grid.Item span={3}>
                                    <span className="titleLeft">
                                        职业
                                    </span>
                                    <span className="titleRight">
                                        {
                                            this.state.userInfo.career == null ? "待完善" : this.state.userInfo.career
                                        }
                                    </span>
                                </Grid.Item>
                                <Grid.Item span={6}>
                                    <span className="titleLeft2">
                                        出生日期
                                    </span>
                                    <span className="titleRight">
                                        {
                                            dayjs(this.state.userInfo.birthday).format("YYYY年MM月DD日")
                                        }
                                    </span>
                                </Grid.Item>
                                <Grid.Item span={6}>
                                    <span className="titleLeft2">
                                        逝世日期
                                    </span>
                                    <span className="titleRight">
                                        {
                                            dayjs(this.state.userInfo.deadDate).format("YYYY年MM月DD日")
                                        }
                                    </span>
                                </Grid.Item>
                                <Grid.Item span={6}>
                                    <div style={{
                                        borderBottom: "solid 2px #e5e5e5", width: "92%",
                                        marginLeft: "4%", marginTop: "5px"
                                    }}></div>
                                </Grid.Item>
                                <Grid.Item span={3}>
                                    <span className="titleLeft">
                                        简介：
                                    </span>
                                </Grid.Item>
                                <Grid.Item span={3}>
                                </Grid.Item>
                                <Grid.Item span={6}>
                                    <div className="titleRight2" style={{ marginBottom: "25px" }}>
                                        {
                                            this.state.userInfo.remark == null ? "待完善" : this.state.userInfo.remark
                                        }
                                    </div>
                                </Grid.Item>

                                {/* <Grid.Item span={6}>
                                    <div style={{
                                        borderBottom: "solid 2px #e5e5e5", width: "92%",
                                        marginLeft: "4%", marginTop: "5px"
                                    }}></div>
                                </Grid.Item> */}

                                {/* <Grid.Item span={2}>
                                    <div className="titleLeft" style={{ marginLeft: "29%" }}>
                                        是否安葬
                                    </div>
                                </Grid.Item>
                                <Grid.Item span={4}>
                                    <div className="titleIsBuried">
                                        <Radio.Group disabled value={
                                            this.state.userInfo.isBuried ? true : false
                                        }>
                                            <Space>
                                                <Radio value={true}>是</Radio>
                                                <Radio value={false}>否</Radio>
                                            </Space>
                                        </Radio.Group>
                                    </div>
                                </Grid.Item> */}

                                {/* {
                                    this.state.userInfo.isBuried ?
                                        <>
                                            <Grid.Item span={6}>
                                                <div style={{ marginBottom: "0px" }}></div>
                                            </Grid.Item>
                                            <Grid.Item span={3}>
                                                <span className="titleLeft">
                                                    公墓地区
                                    </span>
                                                <span className="titleRight">
                                                    {
                                                        this.state.userInfo.hotelAreaName == null ? "待完善" : this.state.userInfo.hotelAreaName
                                                    }
                                                </span>
                                            </Grid.Item>
                                            <Grid.Item span={3}>
                                                <span className="titleLeft">
                                                    公墓
                                    </span>
                                                <span className="titleRight">
                                                    {
                                                        this.state.userInfo.hotelCemeteryName == null ? "待完善" : this.state.userInfo.hotelCemeteryName
                                                    }
                                                </span>
                                            </Grid.Item>
                                            <Grid.Item span={6}>
                                                <span className="titleLeft2">
                                                    公墓号
                                    </span>
                                                <span className="titleRight">
                                                    {
                                                        this.state.userInfo.cemeteryNum == null ? "待完善" : this.state.userInfo.cemeteryNum
                                                    }
                                                </span>
                                            </Grid.Item>

                                        </> : null
                                } */}


                                {/* <Grid.Item span={6}>
                                    <div style={{
                                        borderBottom: "solid 2px #e5e5e5", width: "92%",
                                        marginLeft: "4%", marginTop: "5px"
                                    }}></div>
                                </Grid.Item>
                                <Grid.Item span={6}>
                                    <div style={{ display: "flex", alignItems: "center", marginTop: "8px", marginBottom: "25px" }}>
                                        <span className="titleLeft2" style={{ display: "flex", alignItems: "center" }}>
                                            亲友团
                                        </span>
                                        <Space style={{ marginLeft: "4%", alignItems: "center" }}>

                                            {
                                                this.state.userInfo.planetFamilyGroupDtos == null ? null :
                                                this.state.userInfo.planetFamilyGroupDtos.map((item, index) => {
                                                    if (index < 6) {
                                                        return (<Image
                                                            src={item.creatorUserUrl}
                                                            width={30}
                                                            height={30}
                                                            fit='cover'
                                                            style={{ borderRadius: 32 }}
                                                        />)
                                                    }
                                                })
                                            }

                                            {
                                                (this.state.userInfo.planetFamilyGroupDtos == null ||
                                                    this.state.userInfo.planetFamilyGroupDtos.length < 6) ? null :
                                                    <div
                                                        style={{
                                                            width: 32,
                                                            height: 32,
                                                            borderRadius: 32,
                                                            backgroundColor: "rgb(187 187 187)",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: 12,
                                                            fontWeight: "bold",
                                                            color: "rgb(68 68 68)"
                                                        }}
                                                    >
                                                        +{this.state.userInfo.planetFamilyGroupDtos.length}
                                                    </div>
                                            }
                                            
                                        </Space>
                                    </div>
                                </Grid.Item> */}

                            </Grid>
                        </div>

                    </div>


                    <div style={{ width: "92%", marginLeft: "4%", marginTop: "7%", marginBottom: "5%" }}>
                        <Grid columns={6} gap={8} style={{ marginTop: "12px" }}>
                            <Grid.Item span={this.state.IsAdmin ? 6 : 3}>
                                <div style={{
                                    backgroundImage: "url('https://api.weibinyi.com/images/niannian/1/2-20.png')"
                                    , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                    , marginLeft: this.state.IsAdmin ? "27%" : "10%"
                                    , width: this.state.IsAdmin ? "46%" : "80%"
                                    , textAlign: "center", fontSize: "15px", lineHeight: "38px"
                                    , fontWeight: "600", color: "#fff"
                                }} onClick={handleCopy}>
                                    复 制 链 接
                                </div>
                            </Grid.Item>
                            {
                                this.state.IsAdmin ? null :
                                    <Grid.Item span={3}>
                                        <div style={{
                                            backgroundImage: "url('https://api.weibinyi.com/images/niannian/1/2-20.png')"
                                            , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                            , marginRight: "10%", width: "80%", textAlign: "center", fontSize: "15px", lineHeight: "38px"
                                            , fontWeight: "600", color: "#fff", float: "right"
                                            // , marginLeft: "27%"
                                        }} onClick={() => {
                                            // this.setState({
                                            //     visiblePopup: true,
                                            //     textArea: "",
                                            // })
                                            this.SendPlanetFamilyGroup()
                                        }}>
                                            成 为 管 理 员
                                </div>
                                    </Grid.Item>
                            }
                        </Grid>
                    </div>

                </div>


                <Popup
                    visible={this.state.visiblePopup}
                    onMaskClick={() => {
                        this.setState({
                            visiblePopup: false,
                        })

                    }}
                    bodyStyle={{
                        borderTopLeftRadius: '18px',
                        borderTopRightRadius: '18px',
                        minHeight: '25vh',
                    }}
                >
                    <div style={{
                        backgroundImage: this.state.titleTab == 0 ?
                            "url('https://api.weibinyi.com/images/niannian/3/5-9-25.png')" : ""
                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", minHeight: "25vh"
                    }}>

                        <div className="liuyan" style={{ width: "94%", marginLeft: "3%" }}>
                            <div style={{
                                marginTop: "20px", fontSize: "16px", marginLeft: "5px", fontWeight: "600", marginBottom: "13px"
                            }}>
                                请输入您的申请关键词：
                                <span style={{
                                    textDecoration: "underline",
                                    color: "#1890ff",
                                    marginLeft: "5px"
                                }} onClick={() => {
                                    var array = [
                                        "天堂路远，愿君安息；人间情长，永存心间  --xxx",
                                        "一世辛勤留美德，半生温润化清风  --xxx",
                                        "慈心待世，含笑归真；德泽后人，光照千秋  --xxx",
                                        "平生风义兼师友，来世因缘结弟兄  --xxx",
                                        "君去九泉留伟业，我来何处觅知音  --xxx",
                                        "我是xxx，我想加入您的亲友团",
                                    ];

                                    const availableElegies = array.filter(elegy => elegy !== this.state.textArea);
                                    const randomElegy = availableElegies.length > 0
                                        ? availableElegies[Math.floor(Math.random() * availableElegies.length)]
                                        : array[Math.floor(Math.random() * array.length)];
                                    this.setState({
                                        textArea: randomElegy
                                    });
                                }}>
                                    随机生成
                                </span>
                            </div>

                            <div>
                                <TextArea placeholder={"如：我是xxx，我想加入您的亲友团"}
                                    defaultValue={this.state.textArea}
                                    maxLength={30} rows={2} showCount value={this.state.textArea}
                                    style={{
                                        border: 'solid 1px #c7c7c7', marginTop: '5px', borderRadius: '3%',
                                        marginBottom: '5px', padding: "10px"
                                    }} onChange={(e) => {
                                        this.setState({
                                            textArea: e
                                        })
                                    }}
                                />
                            </div>

                            <div style={{
                                backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/46-10.png')"
                                , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                , fontWeight: "600", color: "#fff", marginTop: "15px"
                            }} onClick={() => {
                                this.SendPlanetFamilyGroup()
                            }}>
                                提 交
                            </div>

                        </div>
                    </div>
                </Popup>



                <Form
                    name='form'
                    layout='horizontal'
                    style={{display:"none"}}
                >



                    <Grid columns={4} gap={8} style={{ marginTop: "15px" }}>
                        <Grid.Item>
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/home_bg.jpg"}
                                    width={70}
                                    height={70}
                                    fit='cover'
                                    style={{ borderRadius: "45px",marginLeft:"15px" }}
                                />
                        </Grid.Item>
                        <Grid.Item span={3}>
                            <div style={{ marginLeft: "15px", lineHeight: "20px" }}>
                                <div style={{ marginTop: "5px" }}>
                                    某某某
                                </div>
                                <div>已化作星星1111天</div>
                                <div>ID：123456</div>
                            </div>
                        </Grid.Item>
                    </Grid>



                    <Divider>基本信息</Divider>

                    <Form.Item
                        name='name'
                        label='性别'
                        rules={[{ required: true, message: '姓名不能为空' }]}
                    >
                        女
                    </Form.Item>


                    <Form.Item
                        name='name2'
                        label='民族'
                    >
                        汉
                    </Form.Item>



                    <Form.Item name='address1' label='信仰' help='详情地址'>
                        基督教
                    </Form.Item>


                    <Form.Item
                        name='name4'
                        label='职业'
                    >
                        农民
                    </Form.Item>


                    <Form.Item
                        name='birthday'
                        label='出生日期'
                    >
                        2024年4月14日13点04分
                    </Form.Item>

                    <Form.Item
                        name='birthday1'
                        label='逝世日期'
                    >
                        2024年4月14日13点04分
                    </Form.Item>

                    <Form.Item name='address' label='简介' help='详情地址'>
                        <Ellipsis
                            content={"蚂蚁的企业级产品是一个庞大且复杂的体系。这类产品不仅量级巨大且功能复杂，而且变动和并发频繁，常常需要设计与开发能够快速的做出响应。同时这类产品中有存在很多类似的页面以及组件，可以通过抽象得到一些稳定且高复用性的内容。"}
                            defaultExpanded={true}
                            expandText='展开'
                            collapseText='收起'
                        />
                    </Form.Item>



                    <Divider>星球相关</Divider>

                    <Form.Item name='sex' label='是否安葬' required>
                        <Radio.Group>
                            <Space direction='horizontal'>
                                <Radio value='1'>是</Radio>
                                <Radio value='2'>否</Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    <Divider>亲友团</Divider>

                    <Space wrap style={{ marginLeft: "8px", marginRight: "8px" }}>
                        <Image
                            src={"https://images.unsplash.com/photo-1567945716310-4745a6b7844b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=60"}
                            width={60}
                            height={60}
                            fit='cover'
                            style={{ borderRadius: 32 }}
                        />
                        <Image
                            src={"https://images.unsplash.com/photo-1567945716310-4745a6b7844b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=60"}
                            width={60}
                            height={60}
                            fit='cover'
                            style={{ borderRadius: 32 }}
                        />
                        <Image
                            src={"https://images.unsplash.com/photo-1567945716310-4745a6b7844b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=60"}
                            width={60}
                            height={60}
                            fit='cover'
                            style={{ borderRadius: 32 }}
                        />
                    </Space>

                </Form>



                <BottomMenu position="absolute" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);